<template>
  <nav
    class="navbar navbar-expand-md fixed-top"
    style="
      margin: unset !important;
      background-color: #fff !important;
      border-bottom: 1px solid #e8e8e8;
      width: 100% !important;
      display: flex;
      justify-content: space-between;
    "
  >
    <div style="display: flex">
      <a href="/">
        <img src="/assets/logo/logo-sq.svg?" style="height: 49px" alt="" />
        <label class="mx-4" style="color: #000">پایگاه داده عمومی ایران</label>
      </a>
    </div>
    <div class="menuList">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item">
          <router-link
            :to="{ name: 'PublicMapHome' }"
            class="nav-link text-dark"
          >
            <i class="bi bi-house-door-fill mx-1"></i>
            {{ $t("home") }}
          </router-link>
        </li>
      </ul>
      <a
        href="/user/"
        class="btn btn-sm btn-dark"
        style="display: flex; height: 38px; margin: auto"
      >
        <i class="bi bi-person" style="margin: auto 4px"></i>
        <span style="margin: auto">ورود کاربران</span>
      </a>
    </div>
  </nav>
</template>


<style scoped>
.menuButtonRes {
  display: none;
}
.menuList {
  display: flex;
  flex-grow: 1;
}
.nav-link:hover {
  color: #a62626 !important;
}

@media (max-width: 1200px) {
  .menuButtonRes {
    display: block;
  }
  .menuList {
    display: none;
  }
  .nav-res {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    width: 100%;
  }
}
</style>